import React, { useEffect } from 'react';
import { useRequirementsAndPayContext } from '../../context';
import { Colors, Text } from 'library';
import { styled } from '@mui/material';
import { GenericChoice, Qualification } from '../../types';
import { experienceChoice, singleChoice } from '../../utils/choices';
import SingleSelect from '../../../BusinessJobRequirementsPage/SingleSelect';
import { PENNSYLVANIA_ROLE_ID } from '../../constants';
import { updateScale } from '../../utils/scale';

enum Role {
    AIDE = 'Aide',
    GROUP_SUPERVISOR = 'Group Supervisor',
    ASSISTANT_GROUP_SUPERVISOR = 'Assistant Group Supervisor',
}

export function PennsylvaniaRequirements({
    update,
}: {
    update: (
        value: number | number[],
        choices: GenericChoice[],
        qualification: Qualification | null,
        category: 'education' | 'experience' | 'multiple' | 'single' | 'boolean',
    ) => void;
}) {
    const { initialScale, qualifications, updateScales } = useRequirementsAndPayContext();
    const paRoleQualification = qualifications.single.find(
        (singleQualification: { qualification: Qualification; choices: GenericChoice[] }) =>
            singleQualification.qualification.id === PENNSYLVANIA_ROLE_ID,
    );

    useEffect(() => {
        let updatedScale = initialScale;
        if (paRoleQualification && selected !== Role.AIDE) {
            updatedScale = updateScale(
                updatedScale,
                paRoleQualification.choices[0].key,
                paRoleQualification.choices,
                paRoleQualification.qualification,
                'single',
            );
        }
        if (qualifications.experience) {
            const choice = experienceChoice(initialScale, qualifications.experience);
            if (!choice || choice !== 1) return;
            updatedScale = updateScale(
                updatedScale,
                qualifications.experience[0].key,
                qualifications.experience,
                null,
                'experience',
            );
        }
        updateScales(updatedScale);
    }, []);

    const selected = paRoleQualification?.qualification.options.find(
        (option) =>
            option.id == singleChoice(initialScale, paRoleQualification.qualification, paRoleQualification.choices),
    )?.value;

    function onChange(val: string | undefined) {
        if (!paRoleQualification) return;

        update(
            paRoleQualification.choices.find((choice) => choice.value === val)?.key ?? 0,
            paRoleQualification.choices,
            paRoleQualification.qualification,
            'single',
        );
    }

    return paRoleQualification ? (
        <Question>
            <div>
                <Text bold>What type of role are you hiring for?</Text>
                <Text variant="caption">
                    Note: All Tandem teachers must meet the minimum requirements for to be an aide. Limiting to the
                    Group Supervisor role will reduce the number of qualified candidates.
                </Text>
                <SingleSelect
                    onChange={onChange}
                    value={selected ?? Role.AIDE}
                    options={paRoleQualification.qualification.options}
                />
            </div>
        </Question>
    ) : null;
}

const Question = styled('div')(({ error }: { error?: string }) => ({
    alignItems: 'center',
    backgroundColor: error === 'true' ? '#fff5f5' : Colors.white,
    borderRadius: 10,
    border: error === 'true' ? `1px solid ${Colors.error}` : 'none',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '5px 20px',
}));
